import { render, staticRenderFns } from "./eventsEditBody.vue?vue&type=template&id=65f71de2&scoped=true"
import script from "./eventsEditBody.vue?vue&type=script&lang=js"
export * from "./eventsEditBody.vue?vue&type=script&lang=js"
import style1 from "./eventsEditBody.vue?vue&type=style&index=1&id=65f71de2&prod&lang=css"
import style2 from "./eventsEditBody.vue?vue&type=style&index=2&id=65f71de2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f71de2",
  null
  
)

export default component.exports